import { connect } from 'react-redux';

import { selectors } from 'dux/user';
import { actionCreators as actions } from 'dux/usersManagement';
import getUsersManagementState from 'dux/usersManagement/selectors';

import UserCardForm from './UserCardForm';

const mapStateToProps = (state) => ({
  ...getUsersManagementState(state),
  actingUserId: selectors.getIdentityState(state).id,
});

const mapDispatchToProps = {
  updateUser: actions.updateUsersState,
  deleteUser: actions.deleteUser,
  getUsers: actions.getUsersState,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserCardForm);
